var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"c_box",attrs:{"type":"flex"}},[_c('Cell',{staticClass:"c_left_box",style:(_vm.style)},[_vm._t("left")],2),_c('Cell',{staticClass:"c_right_box",style:(_vm.style),attrs:{"flex":1}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }